export default "__VITE_ASSET__DFBscSSH__"